<form>
  <ng-container *transloco="let t; read: 'ime.manufacturing.configuration'">
    <ul ngbNav #nav="ngbNav" class="nav-tabs" (navChange)="selectTab($event)" [(activeId)]="currentTab">
      <li ngbNavItem="general" [destroyOnHide]="false">
        <a ngbNavLink>
          <span class="badge bg-danger" *ngIf="(wasValidated$ | async) && !configuration?.isValid()">!</span>
          {{t('General info')}}
        </a>
        <ng-template ngbNavContent>
          <ng-container *ngIf="configuration">
            <div class="row">
              <div class="col">
                <div class="card">
                  <div class="card-body">
                    <div class="row">
                      <div class="col">
                        <div class="form-group row">
                          <label for="code" class="col-sm-4 col-form-label">{{t('Code')}}</label>
                          <div class="col-sm-8">
                            <input type="text" class="form-control" id="code" name="code" [(ngModel)]="configuration.Code" [readonly]="readonly" autocomplete="off">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="itemGroup" class="col-sm-4 col-form-label">{{t('Item Group')}}</label>
                          <div class="col-sm-8">
                            <mes-web-manufacturing-item-group-select [items$]="itemGroupsQuery.getAll$"
                                                                     name="itemGroup" id="itemGroup"
                                                                     [entityId]="configuration.ItemGroupId"
                                                                     (entityIdChange)="configuration.ItemGroupId = $event"
                                                                     [readonly]="readonly"></mes-web-manufacturing-item-group-select>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="itemGroup" class="col-sm-4 col-form-label">{{t('Item')}}</label>
                          <div class="col-sm-8">
                            <mes-web-manufacturing-item-select [items$]="itemsQuery.getAll$"
                                                               name="item" id="item"
                                                               [entityId]="configuration.ItemId"
                                                               (entityIdChange)="configuration.ItemId = $event"
                                                               [readonly]="readonly"></mes-web-manufacturing-item-select>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="code" class="col-sm-4 col-form-label">{{t('ConfigurationBatch Id')}}</label>
                          <div class="col-sm-8">
                            <input type="text" class="form-control" id="ConfigurationBatch" name="ConfigurationBatch" [(ngModel)]="configuration.ConfigurationBatchId" [readonly]="readonly" autocomplete="off">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="status" class="col-sm-4 col-form-label">{{t('Status')}}</label>
                          <div class="col-sm-8">
                            <mes-web-classificator-value-select [entityId]="configuration.StatusClv"
                                                                [readonly]="readonly"
                                                                (entityIdChange)="configuration.StatusClv = $event"
                                                                name="status" id="status"
                                                                [items]="classificatorValuesQuery.configurationStatuses$ | async"
                                                                [allowAdd]="false"></mes-web-classificator-value-select>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="assignedTo" class="col-sm-4 col-form-label">{{t('Assigned To')}}</label>
                          <div class="col-sm-8">
                            <mes-user-select [entityId]="configuration.AssignedTo" [readonly]="readonly" [items$]="usersQuery.getAll$" [allowAdd]="false" name="assignedTo" id="assignedTo"
                                             (entityIdChange)="configuration.AssignedTo = $event; changed.emit(false)"></mes-user-select>
                          </div>
                        </div>
                      </div>
                      <div class="col">
                        <div class="form-group row">
                          <label for="Quantity" class="col-sm-4 col-form-label">{{t('Quantity')}}</label>
                          <div class="col-sm-8">
                            <input type="number" class="form-control bg-white-100" id="Quantity" name="Quantity" [(ngModel)]="configuration.Quantity" [readonly]="readonly">
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="dueDate" class="col-sm-4 col-form-label">{{t('Due Date')}}</label>
                          <div class="col-sm-8">
                            <app-date-time-picker [disabled]="readonly" [(ngModel)]="configuration.DueDate" name="dueDate" id="dueDate"></app-date-time-picker>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="log" class="col-sm-4 col-form-label">{{t('Log')}}</label>
                          <div class="col-sm-8">
                            <textarea class="form-control bg-white-100" id="log" name="log" autosize [(ngModel)]="configuration.Log" [readOnly]="readonly"></textarea>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="modifiedBy" class="col-sm-4 col-form-label">{{t('Modified By')}}</label>
                          <div class="col-sm-8">
                            <mes-user-select [entityId]="configuration.ModifiedBy" [readonly]="true" [items$]="usersQuery.getAll$" [allowAdd]="false" name="modifiedBy" id="modifiedBy"></mes-user-select>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label for="modifiedDate" class="col-sm-4 col-form-label">{{t('Modified Date')}}</label>
                          <div class="col-sm-8">
                            <app-date-time-picker [disabled]="true" [(ngModel)]="configuration.ModifiedDate" name="modifiedDate" id="modifiedDate"></app-date-time-picker>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-2 pb-2">
              <div class="col">
                <div class="card">
                  <div class="card-body">
                    <div class="d-flex pb-1">
                      <h5 class="d-inline-block">{{t('Specs')}}</h5>
                      <help-button *transloco="let h" [key]="h('help.ime.common.specs')"></help-button>
                      <div class="ms-auto">
                        <button class="btn btn-sm btn-outline-primary me-1" [ngClass]="{'active': showPropertyLocalizations}" *ngIf="settings.Property.Localization"
                                (click)="showPropertyLocalizations = !showPropertyLocalizations">
                          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#flag"></svg>
                          {{t('Localization')}}
                        </button>
                        <button class="btn btn-sm btn-outline-primary" (click)="specLinesEditComponent?.addNewSpecLine()" *ngIf="!readonly">
                          <svg viewBox="0 0 8 8" class="icon small" inlineSVG="#plus"></svg>
                          {{t('Add')}}
                        </button>
                      </div>
                    </div>
                    <ime-spec-lines-edit [context]="configuration"
                                         [showLocalization]="showPropertyLocalizations"
                                         [showLocalizationButton]="settings.Property.Localization"
                                         [wasValidated$]="wasValidated$"
                                         [readonly]="readonly"
                                         (changed)="onSpecChanged($event)"></ime-spec-lines-edit>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-template>
      </li>
      <li ngbNavItem="ime" [destroyOnHide]="false">
        <a ngbNavLink>
          {{t('IME')}}
        </a>
        <ng-template ngbNavContent>
          <mes-web-integrated-master-editor *ngIf="configuration?.isImeLoaded()"
                                            [masterOperations]="configuration.MasterOperations"
                                            [processSelectors]="configuration.ProcessSelectors"
                                            [allowItemGroupsAsInputs]="settings.Ime.Features.AllowItemGroupAsInput"
                                            [allowItemGroupsAsOutputs]="settings.Ime.Features.AllowItemGroupAsOutput"
                                            [allowResourceTemplate]="settings.Ime.Features.AllowResourceTemplate"
                                            [readonly]="readonly"
                                            (processSelectorChanged)="configuration.ProcessSelectors = $event; setChanged()"
                                            (masterOperationChanged)="configuration.MasterOperations = $event; setChanged()">
          </mes-web-integrated-master-editor>
        </ng-template>
      </li>
    </ul>
    <div [ngbNavOutlet]="nav"></div>
  </ng-container>
</form>
